import { AuditSocialMediaPostsController } from './audit-social-media-posts.controller'

function auditSocialMediaPosts () {
  return {
    restrict: 'E',
    scope: {
      filters: '<'
    },
    templateUrl: '/audit/directives/audit-social-media-posts/audit-social-media-posts.html?$$REVISION$$',
    controller: AuditSocialMediaPostsController
  }
}

export { auditSocialMediaPosts }
